<header>
  <app-header></app-header>
</header>
<div class="container-xxl my-md-4 bd-layout grid">
  <aside class="sidebar" *ngIf="verMenuLateral">
    <app-sidebar [verUrlRepository]="false"></app-sidebar>
  </aside>
  <main class="main">
    <router-outlet></router-outlet>
  </main>
  <app-servicios-entidades></app-servicios-entidades>
</div>
<div class="banner">
  <div class="container container-nota-legal">
    <p>Nota legal: El código fuente de cada componente presente en esta versión del CDN cumple con los requerimientos mínimos exigidos por la normatividad vigente. Sin embargo, es responsabilidad de cada entidad, cuando integre estos componentes a sus soluciones digitales, el continuar garantizando el cumplimiento de los criterios de usabilidad, accesibilidad y funcionalidad de los mismos.</p>
  </div>
</div>
<footer class="footer-out" aria-label="Pie de página - Datos de contacto y enlaces de interés">
  <section class="container">
    <govco-footer-3></govco-footer-3>
  </section>
</footer>
